import moment from 'moment';

const sensorBlankIcon = require('./assets/icons/svg/blank-sensor.svg');
const temperatureIcon = require('./assets/icons/svg/temperature.svg');
const cloudConnectorIcon = require('./assets/icons/svg/cloud-connector.svg');
const windowIcon = require('./assets/icons/svg/window.svg');
const windowOpenIcon = require('./assets/icons/svg/window-open.svg');
const doorIcon = require('./assets/icons/svg/door.svg');
const doorClosedIcon = require('./assets/icons/svg/door-closed.svg');
const theftIcon = require('./assets/icons/svg/theft.svg');
const touchIcon = require('./assets/icons/svg/touch.svg');
const starIcon = require('./assets/icons/svg/star.svg');
const starOutlineIcon = require('./assets/icons/svg/star-o.svg');
const iconSignalIcon0 = require('./assets/icons/svg/icon_signal0.svg');
const iconSignalIcon1 = require('./assets/icons/svg/icon_signal1.svg');
const iconSignalIcon2 = require('./assets/icons/svg/icon_signal2.svg');
const iconSignalIcon3 = require('./assets/icons/svg/icon_signal3.svg');
const iconSignalIcon4 = require('./assets/icons/svg/icon_signal4.svg');
const iconSignalIcon5 = require('./assets/icons/svg/icon_signal5.svg');
const tableSortable = require('./assets/icons/svg/table-sortable.svg');
const tableSortedAsc = require('./assets/icons/svg/table-sorted-asc.svg');

/**
 * Application configuration class
 * @constructor
 * @ngInject
 */
function AppConfig($mdThemingProvider, $mdIconProvider, $mdDateLocaleProvider, $compileProvider) {
    if (NODE_ENV === 'production') {
        $compileProvider.debugInfoEnabled(false);
        $compileProvider.commentDirectivesEnabled(false);
        $compileProvider.cssClassDirectivesEnabled(false);
    }

    $mdDateLocaleProvider.formatDate = function (date) {
        return moment(date).format('DD/MM/YY');
    };

    const customLightBlue = $mdThemingProvider.extendPalette('blue-grey', {
        '50': '#ECEFF1',
        '100': '#CFD8DC',
        '200': '#89bad6', // custom
        '300': '#90A4AE',
        '400': '#78909C',
        '500': '#42a0d6', // custom
        '600': '#2d79a5', // custom
        '700': '#455A64',
        '800': '#37474F',
        '900': '#263238',
        'contrastDefaultColor': 'light',
        'contrastLightColors': '400 500 600 700 800 900',
        'contrastStrongLightColors': '400 600 700 800 900'
    });

    const customRed = $mdThemingProvider.extendPalette('red', {
        '50': '#ffebee',
        '100': '#ffcdd2',
        '200': '#ef9a9a',
        '300': '#e57373',
        '400': '#E11F30', // custom
        '500': '#f44336',
        '600': '#e53935',
        '700': '#d32f2f',
        '800': '#c62828',
        '900': '#b71c1c',
        'A100': '#ff8a80',
        'A200': '#ff5252',
        'A400': '#ff1744',
        'A700': '#ff0008', // custom
        'contrastDefaultColor': 'light',
        'contrastDarkColors': '50 100 200 300 A100',
        'contrastStrongLightColors': '400 500 600 700 A200 A400 A700'
    });
    $mdThemingProvider.definePalette('customLightBlue', customLightBlue);

    $mdThemingProvider.definePalette('customRed', customRed);


    $mdThemingProvider.theme('default')
        .primaryPalette('customLightBlue')
        .accentPalette('customLightBlue')
        .warnPalette('customRed')
    ;

    $mdThemingProvider.theme('dark')
        .primaryPalette('yellow')
        .dark()
        .foregroundPalette['4'] = 'rgba(221, 221, 221, 1)'
    ;

    // Configure icons
    $mdIconProvider
        .icon('sensor-blank', sensorBlankIcon)
        .icon('cloud-connector', cloudConnectorIcon)
        .icon('door', doorIcon)
        .icon('door-closed', doorClosedIcon)
        .icon('temperature', temperatureIcon)
        .icon('window', windowIcon)
        .icon('window-open', windowOpenIcon)
        .icon('theft', theftIcon)
        .icon('touch', touchIcon)
        .icon('star', starIcon)
        .icon('star-o', starOutlineIcon)
        .icon('icon_signal0', iconSignalIcon0)
        .icon('icon_signal1', iconSignalIcon1)
        .icon('icon_signal2', iconSignalIcon2)
        .icon('icon_signal3', iconSignalIcon3)
        .icon('icon_signal4', iconSignalIcon4)
        .icon('icon_signal5', iconSignalIcon5)
        .icon('table-sortable', tableSortable)
        .icon('table-sorted', tableSortedAsc)
    ;

    // $animateProvider.classNameFilter(/dt-animated/);
}

/**
 * EventEmitter is wrapper and used to ease migration in future to angular 2
 * @type {Object}
 */
const EventEmitter = {
    name: 'EventEmitter',
    definition: payload => ({ $event: payload })
};

export {
    AppConfig,
    EventEmitter
};



// WEBPACK FOOTER //
// ./app/app.config.js